import { BillingType } from "@redotech/redo-billing-common/billing-window-config-definition";
import * as z from "zod";

/** Restart a team's SMS, email or Recover plan on a future date. Only for
 * plans whose bills so far are all $0 with no payments. */
export const restartBillingPlan = {
  name: "restartBillingPlan" as const,
  input: z.object({
    teamId: z.string(),
    billingType: z.enum([
      BillingType.MARKETING_SMS,
      BillingType.MARKETING_EMAIL,
      BillingType.RECOVER,
    ]),
    startDate: z.date(),
  }),
  output: z.object({ deletedBillCount: z.number() }),
};
